<template>
  <div class="page">
    <div style="position:absolute;top:50px;right:50px;">
      <el-button type="primary" @click="showReply">{{$t('afterSales.text52')}}</el-button>
    </div>
    <div class="reply-order">
      <div class="order-title">
        <span style="font-weight:bold;">{{$t('afterSales.text40')}}</span><span>：{{ workOrder.id}}</span>
        <span style="font-weight:bold;margin-left:30px;">{{$t('afterSales.text41')}}</span><span>：{{ workStatus(workOrder.status)}}</span>
        <span style="font-weight:bold;margin-left:30px;">{{$t('afterSales.text47')}}</span><span>：{{ faultLevel(workOrder.faultLevel)}}</span>
        <span style="font-weight:bold;margin-left:30px;">{{$t('afterSales.text36')}}</span><span>：{{ workOrder.createdAt }}</span>
        <span style="font-weight:bold;margin-left:30px;">{{$t('pages.user.text5')}}</span><span>：{{ workOrder.appAccount }}</span>
        <span style="font-weight:bold;margin-left:30px;">{{$t('afterSales.text48')}}</span><span style="overflow-x:auto;">：{{ workOrder.subject }}</span>
      </div>
      <div class="order-title" style="margin-top:20px;">
        <span style="font-weight:bold;">{{$t('afterSales.text38')}}</span><span>：{{ workOrder.faultInfo }}</span>
      </div>
      <div class="order-title" style="margin-top:20px;">
        <span style="font-weight:bold;">{{$t('afterSales.text53')}}：</span>
        <el-image v-if="workOrder.faultPics && workOrder.faultPics.length > 0" :src="workOrder.faultPics[0]" style="width:200px;height:auto;" :preview-src-list="workOrder.faultPics"/>
        <el-image v-if="workOrder.faultPics && workOrder.faultPics.length > 1" :src="workOrder.faultPics[1]" style="width:200px;height:auto;margin-left:10px;" :preview-src-list="workOrder.faultPics"/>
        <el-image v-if="workOrder.faultPics && workOrder.faultPics.length > 2" :src="workOrder.faultPics[2]" style="width:200px;height:auto;margin-left:10px;" :preview-src-list="workOrder.faultPics"/>
        <el-image v-if="workOrder.faultPics && workOrder.faultPics.length > 3" :src="workOrder.faultPics[3]" style="width:200px;height:auto;margin-left:10px;" :preview-src-list="workOrder.faultPics"/>
      </div>
      <div style="font-weight:bold;margin-top:30px;font-size:20px;">{{$t('afterSales.text54')}}</div>
      <div style="height:20px;">&nbsp;</div>
      <div v-if="messages.length === 0" class="no-messages">{{$t('afterSales.text55')}}</div>
      <div v-for="(message, index) in messages" :key="index">
        <div class="message-item" :class="message.sendFrom === 'customer' ? 'customer-message' : 'support-message'">
          <div class="message-header">
            <span class="sender">{{ (message.sendFrom === 'customer' ? $t('afterSales.text62') : $t('afterSales.text63')) + ' ' + message.sender }}</span>
            <span class="time">{{ message.createdAt }}</span>
          </div>
          <div class="message-content">
            <div class="text-content">{{ message.content }}</div>
            <div v-if="message.mediaList && message.mediaList.length > 0" class="media-content">
              <div v-for="(media, mediaIndex) in message.mediaList" :key="mediaIndex" class="media-item" @click="previewMedia(media)">
                <img v-if="media.ftype === 'image'" :src="media.url" alt="image">
                <video v-else-if="media.ftype === 'video'" :src="media.url" :poster="media.poster"></video>
                <div class="media-type-tag">
                  {{ media.ftype === 'image' ? $t('afterSales.text56') : $t('afterSales.text57') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <br/>
      </div>
    </div>
    <!-- 回复对话框 -->
    <el-dialog
        :title="$t('afterSales.text52')"
        :visible.sync="dialogVisible"
        class="reply-dialog"
        width="600px"
        :before-close="dialogClose">
        
        <div class="reply-content">

            <el-input
              type="textarea"
              :rows="4"
              :placeholder="$t('afterSales.text58')"
              v-model="replyText"/>
            
            <DiluUploadImage 
              :limit="4" 
              accept=".png,.jpg,.jpeg,.mp4,.avi" 
              :fileList="fileList" 
              @remove="removeimg" 
              @success="success"/>
            
            <div class="reply-actions">
                <el-button @click="dialogClose">{{ $t('button.close') }}</el-button>
                <el-button type="primary" @click="sendMessage" :loading="sending">{{ $t('afterSales.text61') }}</el-button>
            </div>

        </div>
      </el-dialog>
      <!-- 媒体预览对话框 -->
      <el-dialog
          :visible.sync="previewDialogVisible"
          class="image-preview-modal"
          width="70%"
          center>
          <div v-if="currentPreviewMedia">
              <img v-if="currentPreviewMedia.ftype === 'image'" :src="currentPreviewMedia.url" alt="image"/>
              <video v-else-if="currentPreviewMedia.ftype === 'video'" :src="currentPreviewMedia.url" controls autoplay style="max-width: 100%;"/>
          </div>
      </el-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex";
import DiluUploadImage from "../../../components/pubilc/dilu-uploadimages.vue";
export default {
  data() {
    return {
      fileList: [],
      replyText: '',
      previewDialogVisible: false,
      currentPreviewMedia: null,
      dialogVisible: false,
      sending: false,
      messages: [],
      workOrder: {
        id: null, 
        status: null,
        appAcoount: null, 
        subject: null, 
        faultInfo: null,
        faultLevel: null,
        faultPics: null,
      },
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  components: {
    DiluUploadImage
  },
  mounted() {
    this.workOrder = this.$route.query.workOrder;
    if (this.workOrder.faultPics!=null&&this.workOrder.faultPics!='') {
      this.workOrder.faultPics=this.workOrder.faultPics;
    }
    this.loadWorkChat();
  },
  methods: {

    //删除图片
    removeimg(e) {
      const i = this.fileList.findIndex((x) => x.name == e);
      this.fileList.splice(i, 1);
    },
    
    //上传成功
    success(e) {
      this.fileList = e.fileList;
    },

    //获取交流记录
    loadWorkChat() {
      const that=this;
      that.request.workChatList({workOrder:that.workOrder.id}).then((res) => {
        if (res.code==0) {
          that.messages=res.data;
          if (that.messages!=null&&that.messages.length>0) {
            for (var i=0; i<that.messages.length; i++) {
              if (that.messages[i].senderType=='customer') {
                that.messages[i].sender=that.$t("afterSales.text62");
              } else if (that.messages[i].senderType=='support') {
                that.messages[i].sender=that.$t("afterSales.text63");
              }
            }
          }
        }
      });
    },

    //显示工单状态
    workStatus(status) {
      if (status==10) {
        return this.$t("afterSales.text42");
      } else if (status==20) {
        return this.$t("afterSales.text43");
      } else if (status==30) {
        return this.$t("afterSales.text44");
      } else if (status==40) {
        return this.$t("afterSales.text45");
      } else if (status==50) {
        return this.$t("afterSales.text46");
      }
    },

    //显示紧急程度
    faultLevel(level) {
      if (level=='high') {
        return this.$t("afterSales.text49");
      } else if (level=='middle') {
        return this.$t("afterSales.text50");
      } else if (level=='low') {
        return this.$t("afterSales.text51");
      }
    },

    //关闭回复对话框
    dialogClose() {
      this.dialogVisible = false;
      this.fileList=[];
      this.replyText="";
    },

    //回复工单
    showReply() {
      this.fileList=[];
      this.replyText="";
      this.dialogVisible=true;
    },

    // 发送消息
    sendMessage() {
      const that=this;
      if (!that.replyText.trim()) {
          that.$message.warning(that.$t('afterSales.text66'));
          return;
      }
      var mediaUrl="";
      for (var i=0; i<that.fileList.length; i++) {
        if (mediaUrl=="") {
          mediaUrl=that.fileList[i].url;
        } else {
          mediaUrl=mediaUrl+","+that.fileList[i].url;
        }
      }
      var params={
        "workOrder": that.workOrder.id,
        "content": that.replyText.trim(),
        "mediaUrl": mediaUrl
      }
      that.sending = true;
      that.request.replyChat(params).then((res) => {
        if (res.code==0) {
          that.dialogVisible=false;
          this.loadWorkChat();
        }
      }); 
    },
    
    // 预览媒体
    previewMedia(media) {
      this.currentPreviewMedia = media;
      this.previewDialogVisible = true;
    },

  },
};
</script>

<style scoped>
.reply-order {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.order-title {
  display: flex;
  flex-direction: row;
}
.message-item {
  padding: 15px 20px;
}
.message-item:last-child {
  border-bottom: none;
}
.message-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.sender {
  font-weight: bold;
  color: #333;
}
.time {
  color: #999;
  font-size: 13px;
}
.message-content {
  margin-top: 8px;
}
.text-content {
  white-space: pre-line;
  line-height: 1.6;
  margin-bottom: 10px;
}
.media-content {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.media-item {
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  transition: transform 0.3s;
}
.media-item:hover {
  transform: scale(1.03);
}
.media-item img, .media-item video {
  width: 150px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.media-type-tag {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 12px;
}
.customer-message {
  background-color: #f0f9ff;
}
.support-message {
  background-color: #f9f9f9;
}
.no-messages {
  text-align: left;
  color: #999;
}
.action-buttons {
  padding: 15px 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e6e6e6;
}
.image-preview-modal .el-dialog__body {
  text-align: center;
}
.image-preview-modal img, .image-preview-modal video {
  max-width: 100%;
  max-height: 70vh;
}
.upload-area {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: border-color 0.3s;
  padding: 10px;
  text-align: center;
  background-color: #fafafa;
}
.upload-area:hover {
  border-color: #409EFF;
}
.upload-icon {
  font-size: 40px;
  color: #c0c4cc;
  margin-bottom: 10px;
}
.upload-text {
  color: #606266;
  font-size: 14px;
}
.uploaded-files {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}
.uploaded-file {
  position: relative;
  width: 100px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
}
.uploaded-file img, .uploaded-file video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.file-remove {
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
}
.reply-dialog .el-dialog__body {
  padding: 20px;
}
.reply-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.reply-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}
.floating-reply-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
}
.floating-reply-btn .el-button {
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  font-size: 24px;
}
</style>